module.exports = __webpack_public_path__ + "img/photo6.6b708be8.jpg";